import { IKeyword } from './types'

export const badKeywords: IKeyword[] = [
  {
    alias: 'LOGCAT_FILE',
    info: 'Start of logcat.txt',
    name: 'logcat.txt',
    signature: '###logcat.txt###',
  },
  {
    alias: 'LOGCAT_FILE',
    info: 'Start of logcat.txt.1',
    name: 'logcat.txt.1',
    signature: '###logcat.txt.1###',
  },
  {
    alias: 'LOGCAT_FILE',
    info: 'Start of logcat.txt.01',
    name: 'logcat.txt.1',
    signature: '###logcat.txt.01###',
  },
  {
    alias: 'LOGCAT_FILE',
    info: 'Start of logcat.txt.2',
    name: 'logcat.txt.2',
    signature: '###logcat.txt.2###',
  },
  {
    alias: 'LOGCAT_FILE',
    info: 'Start of logcat.txt.02',
    name: 'logcat.txt.02',
    signature: '###logcat.txt.02###',
  },
  {
    alias: 'LOGCAT_FILE',
    info: 'Start of logcat.txt.3',
    name: 'logcat.txt.3',
    signature: '###logcat.txt.3###',
  },
  {
    alias: 'LOGCAT_FILE',
    info: 'Start of logcat.txt.03',
    name: 'logcat.txt.03',
    signature: '###logcat.txt.03###',
  },
  {
    alias: 'LOGCAT_FILE',
    info: 'Start of logcat.txt.3',
    name: 'logcat.txt.3',
    signature: '###logcat.txt.3###',
  },
  {
    alias: 'LOGCAT_FILE',
    info: 'Start of logcat.txt.4',
    name: 'logcat.txt.4',
    signature: '###logcat.txt.4###',
  },
  {
    alias: 'LOGCAT_FILE',
    info: 'Start of logcat.txt.04',
    name: 'logcat.txt.04',
    signature: '###logcat.txt.04###',
  },
  {
    alias: 'LOGCAT_FILE',
    info: 'Start of logcat.txt.5',
    name: 'logcat.txt.5',
    signature: '###logcat.txt.5###',
  },
  {
    alias: 'LOGCAT_FILE',
    info: 'Start of logcat.txt.05',
    name: 'logcat.txt.05',
    signature: '###logcat.txt.05###',
  },
  {
    alias: 'LOGCAT_FILE',
    info: 'Start of logcat.txt.6',
    name: 'logcat.txt.6',
    signature: '###logcat.txt.6###',
  },
  {
    alias: 'LOGCAT_FILE',
    info: 'Start of logcat.txt.06',
    name: 'logcat.txt.06',
    signature: '###logcat.txt.06###',
  },
  {
    alias: 'LOGCAT_FILE',
    info: 'Start of logcat.txt.7',
    name: 'logcat.txt.7',
    signature: '###logcat.txt.7###',
  },
  {
    alias: 'LOGCAT_FILE',
    info: 'Start of logcat.txt.07',
    name: 'logcat.txt.07',
    signature: '###logcat.txt.07###',
  },
  {
    alias: 'LOGCAT_FILE',
    info: 'Start of logcat.txt.8',
    name: 'logcat.txt.8',
    signature: '###logcat.txt.8###',
  },
  {
    alias: 'LOGCAT_FILE',
    info: 'Start of logcat.txt.08',
    name: 'logcat.txt.08',
    signature: '###logcat.txt.08###',
  },
  {
    alias: 'LOGCAT_FILE',
    info: 'Start of logcat.txt.9',
    name: 'logcat.txt.9',
    signature: '###logcat.txt.9###',
  },
  {
    alias: 'LOGCAT_FILE',
    info: 'Start of logcat.txt.09',
    name: 'logcat.txt.09',
    signature: '###logcat.txt.09###',
  },
  {
    alias: 'LOGCAT_FILE',
    info: 'Start of logcat.txt.10',
    name: 'logcat.txt.10',
    signature: '###logcat.txt.10###',
  },
  {
    alias: 'COULD_NOT_CREATE_WAKE_PIPE',
    info: 'Out of file descriptors.',
    name: 'Could not create wake pipe',
    signature: 'Could not create wake pipe. errno=24',
  },
  {
    alias: 'TOO_MANY_OPEN_FILES',
    info: 'Out of file descriptors.',
    name: 'Too many open files',
    signature: 'too many open files',
  },
  {
    alias: 'BAD_FILE_NUMBER',
    info: 'Seen in multiple places, but usually when trying to bring up ethernet interface.',
    name: 'Bad file number',
    signature: 'bad file number',
  },
  {
    alias: 'BEGINNING_OF_CRASH',
    info: 'Marker where crash/abort started.',
    name: 'Beginning of crash',
    signature: 'beginning of crash',
  },
  {
    alias: 'BEGINNING_OF_MAIN',
    info: 'Marker where system started booting.', // this comes before system
    name: 'Beginning of main',
    signature: 'beginning of main',
  },
  {
    alias: 'BEGINNING_OF_SYSTEM',
    info: 'Marker where system started booting.',
    name: 'Beginning of system',
    signature: 'beginning of system',
  },
  {
    // SolsticeServer Solstice server created
    alias: 'SOLSTICE_SERVER_CREATED',
    info: 'Solstice application starting. This is different from the system booting.', // this comes before system
    name: 'Solstice starting',
    signature: 'SolsticeServer Solstice server created',
  },
  {
    alias: 'OUT_OF_MEMORY',
    info: 'Pod has run out of memory. Once is a pod is in this state, it will likely be unresponsive, and will almost certainly crash shortly after.',
    name: 'Out of memory',
    signature: 'out of memory',
  },
  {
    // 08-23 08:49:27.757  1873  2157 D CommandListener: Setting iface cfg
    // 08-23 08:49:27.757  1873  2157 D CommandListener: Trying to bring up eth0
    // 08-23 08:49:27.811  2486  2668 D EthernetInterface: Try Setting Static IP
    // 08-23 08:49:27.815  1949 27388 F Looper  : Could not create wake pipe.  errno=24
    // 08-23 08:49:27.816  1949 27388 F libc    : Fatal signal 6 (SIGABRT), code -6 in tid 27388 (DelayedDiskWrit)
    alias: 'DELAYED_DISK_WRITE',
    info: 'Seen on libc abort when failing to set static IP. Should not be present with Dustin\'s retry logic.',
    name: 'Delayed disk write',
    signature: 'DelayedDiskWrit',
  },
  {
    // 08-24 09:18:42.744 29108 29478 W libc    : pthread_create failed: couldn't allocate 1040384-byte stack: Out of memory
    // 08-24 09:18:42.752 29108 24517 F libc    : stack corruption detected
    alias: 'STACK_CORRUPTION',
    info: 'Memory stack is corrupted and pod will certainly crash. Often seen when pod is out of memory.',
    name: 'stack corruption',
    signature: 'stack corruption detected',
  },
  {
    alias: 'HEALTH_CHECK_SELF_CONNECT_1',
    info: 'Health checker could not connect to localhost once.',
    name: 'Self connect failed once',
    signature: 'HealthChecker: unable to connect to localhost 1',
  },
  {
    alias: 'HEALTH_CHECK_SELF_CONNECT_2',
    info: 'Health checker could not connect to localhost twice. If this happens once more, Solstice will print stack traces and abort (restart Solstice).',
    name: 'Self connect failed twice',
    signature: 'HealthChecker: unable to connect to localhost 2',
  },
  {
    alias: 'HEALTH_CHECK_SELF_CONNECT_3',
    info: 'Health checker could not connect to localhost three times in as many minutes, Solstice will dump traces and abort (restart Solstice).',
    name: 'Self connect dumped and aborted',
    signature: 'HealthChecker: unable to connect to localhost 3',
  },
  {
    alias: 'HEALTH_CHECK_BLOCKED_THREAD',
    info: 'Health checker detected a blocked thread for more than 1 hour, dumping traces and aborting (restart Solstice).',
    name: 'Blocked thread (1 hour)',
    // signature: 'Dumping thread stacks native',
    signature: 'GetUnwind (null)',
  },
  {
    // 'Interface down, upping before setting setting static IP',
    alias: 'DUSTIN_SECOND_ETHERNET_FIX',
    info: 'The interface was down when trying to set static IP. We\'ve only seen this attempted fix log line once.',
    name: 'Dustin\'s second ethernet fix',
    signature: 'setting setting',
  },
  {
    alias: 'GRACEFUL_SHUTDOWN',
    info: 'A graceful shutdown, either from an update, the API, or user initiated. This is not a crash.',
    name: 'Shutting down',
    signature: 'ShutdownThread: Notifying',
  },
  {
    alias: 'FATAL_EXCEPTION_SYSTEM_PROCESS',
    info: 'Seen when pods are stuck in boot loops, possibly with memory corruption.',
    name: 'Fatal exception',
    signature: 'FATAL EXCEPTION IN SYSTEM PROCESS',
  },
  {
    // 08-20 03:04:25.415 14831 14849 E JavaBinder: !!! FAILED BINDER TRANSACTION !!!
    // 08-20 03:04:25.450 14831 16869 I ActivityManager: Process com.mersive.solstice.server (pid 18186) has died
    // 08-20 03:04:25.470 14831 16869 I ActivityManager: Start proc 18203:com.mersive.solstice.server/u0a9 for activity com.mersive.solstice.server/.ServerDisplay
    alias: 'FAILED_BINDER_TRANSACTION',
    info: 'Low level Android message dealing with Solstice process. May have failed to start, or just died.', // TODO
    name: 'Failed binder transaction',
    signature: '!!! FAILED BINDER TRANSACTION !!!',
  },
  {
    // TimerCallback   Webview has not requested data for more than 60 seconds.        ../../..\Solstice/Server/Renderer/Src/Presentation2Impl.h        6059
    alias: 'WEBVIEW_HASNT_REQUESTED',
    info: `
      The modern splash webview front end has not requested data from the backend for 1 minute.
      This may be an issue with the HTTP server, the React application, or we have degraded performance.
      This requires a backend logging to fix to ensure that this message is not generated errenously, such as when the browser is running the background.
    `,
    name: 'WebView hasn\'t requested data',
    signature: 'Webview has not requested data',
  },
  // {
  //   // Execute RETURN Result: 0x80000007 - Timeout Connection: 378feead-7caf-54b1-2f57-6048ce16de35 Object: c54a83a0-d9d2-11e1-9b23-0800200c9a66 Method: 6 (20000 ms)   jni/../../../
  //   alias: 'RETURN_RESULT_0x80000007',
  //   info: 'Suspicious - seen around when NotificationThread gets blocked.',
  //   name: 'Return result 0x80000007',
  //   signature: 'Execute RETURN Result: 0x80000007 - Timeout Connection:',
  // },
  {
    alias: 'LOGS_FETCHED',
    info: 'When logs were fetched from the pod.',
    name: 'Logs fetched',
    signature: 'HandleLogsZipRequest runcon',
  },
  {
    alias: 'DHCP_TIMED_OUT',
    info: 'A network interface requested a DHCP request, but the request timed out. The network interface may lose connectivity after this point.',
    name: 'DHCP timed out',
    signature: 'dhcpcd  : timed out',
  },
  {
    alias: 'DHCP_BROADCASTING',
    info: 'A network interface is broadcast a DHCP request. The interface should received a response with an IP address shortly after.',
    name: 'DHCP broadcast request',
    signature: 'broadcasting for a lease',
  },
  {
    // 10-17 01:09:50.145   852 27977 I WindowState: WIN DEATH: Window{24e69e7c u0 com.mersive.solstice.server/com.mersive.solstice.server.DigitalSignage}
    alias: 'WIN_DEATH',
    info: 'A window/activity has died, causing it not to be displayed. A sign of serious pod instability. This is not related/specific to the Windows Solstice server. This may be the Solstice or Digital Signage window.',
    name: 'Window died',
    signature: 'WindowState: WIN DEATH:',
  },
  {
    // 10-17 01:09:49.871  3196  3196 I Choreographer: Skipped 238 frames!  The application may be doing too much work on its main thread.
    alias: 'SKIPPED_FRAMES',
    info: 'Frames have been skipped from rendering. A sign of bad performance/instability. We\'ve also seen this log line when customers report black or frozen screens.',
    name: 'Skipped frames',
    signature: 'Choreographer: Skipped ',
  },
  {
    // 10-17 11:39:07.884  1471  1471 I chromium: [INFO:CONSOLE(0)] "[.WebGL-0x99ad7b00]GL ERROR :GL_OUT_OF_MEMORY : glBufferData: <- error from previous GL command", source: http://kitchen.screenfeed.com/social/v2/0k1gzfq9dj2r0hjemnf7k24vac.html (0)
    alias: 'GL_OUT_OF_MEMORY',
    info: 'Web GL was unable to allocate memory. This happens when a page within a browser (usually digital signage) makes a WebGL call attempting to allocate graphics memory. A sign of serious instability, seen shortly before crashes.',
    name: 'WebGL out of memory',
    signature: 'GL ERROR :GL_OUT_OF_MEMORY',
  },
  {
    // 10-17 11:59:21.776 21208 21261 F chromium: [FATAL:memory.cc(22)] Out of memorydn. size=11190272
    alias: 'CHROMIUM_OUT_OF_MEMORY',
    info: 'Chrome was unable to allocate memory. Usually exhibited when a digital signage URL consumes a large amount of memory. A serious instability issue seen shortly before a pod crashes.',
    name: 'Chrome out of memory',
    signature: 'chromium: [FATAL:memory.cc(22)] Out of memory',
  },
  {
    // 10-17 11:59:22.141 27089 21261 F google-breakpad: -----BEGIN BREAKPAD MICRODUMP-----
    alias: 'GOOGLE_BREAKPAD',
    info: 'Chrome has crashed (usually due to lack of memory) and has dumped stack traces. As Chrome runs within Solstice, this means Solstice will have crashed too.',
    name: 'Chrome crash',
    signature: 'google-breakpad: -----BEGIN BREAKPAD MICRODUMP-----',
  },
  {
    // 10-12 17:34:39.388  1498  5838 E SOLSTICE_LOGGER: 10/12/2018 17:34:39.387 5838 * Severe      * Lock Lock held by thread=5687 for more than 1 secs /Users/mersive/Data/code/Sol-Windows/Common/Platform/Android/Src/MutexImpl.cpp 158
    alias: 'POSSIBLE_DEADLOCK',
    info: 'A thread has held a lock on a mutex for more than a second, a sign of a possible deadlock.',
    name: 'Possible deadlock',
    signature: 'Lock Lock held by thread=',
  },
  {
    alias: 'APPLY_PATCH_FAILED',
    info: 'An SELinux denial occurred while attempting to apply a patch',
    name: 'Patch Failed',
    signature: 'applypatch: type=1400 audit(0.0:4): avc: denied { create } for name="recovery.patch" scontext=u:r:install_recovery:s0 tcontext=u:object_r:block_device:s0 tclass=file',
  },
  {
    // 01-01 23:04:25.423  1393  8255 D SOLSTICE_LOGGER: 01/01/1970 23:04:25.423 8255  Information  javaLog installAPK: Before doing the install, copying current files for possible future rollback jni/../../../../Solstice/Server/AndroidServer/jni/main.cpp 47
    alias: 'PRE_INSTALL',
    info: 'Solstice APK install about to happen.',
    name: 'Pre install',
    signature: 'javaLog installAPK: Before doing the install, copying current files for possible future rollback',
  },
  {
    // 01-01 23:04:36.065  8374  8389 D DefContainer: Copying /sdcard/Download/installer.apk to base.apk
    alias: 'COPYING_APK',
    info: 'Copying Solstice APK install to pod.',
    name: 'Copying APK',
    signature: 'DefContainer: Copying /sdcard/Download/installer.apk to base.apk',
  },
  {
    // 01-01 23:04:34.242  1393  8255 D SOLSTICE_LOGGER: 01/01/1970 23:04:34.241 8255  Information  javaLog installAPK: Installing apk at /sdcard/Download/installer.apk jni/../../../../Solstice/Server/AndroidServer/jni/main.cpp 47
    alias: 'INSTALLING_APK',
    info: 'Installing Solstice APK install to pod.',
    name: 'Installing APK',
    signature: 'javaLog installAPK: Installing apk at ',
  },
  {
    // 01-01 00:00:17.843   680   680 I recovery: Installing new recovery image: failed
    alias: 'INSTALLING_RECOVERY_FAILED',
    info: 'Failed to install new recovery image. This sounds serious, is it? You find out.',
    name: 'Failed to install recovery image.',
    signature: 'recovery: Installing new recovery image: failed',
  },
  {
    // 10-24 12:55:41.306  1467 26041 D SOLSTICE_LOGGER: 10/24/2018 12:55:41.306 26041  Information  OnDataReady Found handler for requestUri = '/Config/service/restart'
    alias: 'API_RESTART',
    info: 'Solstice application (not whole device/OS) restarted via /Config/service/restart API. This takes a few seconds, shows a grey screen while it happens.',
    name: 'API Solstice restart',
    signature: "Found handler for requestUri = '/Config/service/restart'",
  },
  {
    // 10-24 12:55:41.306  1467 26041 D SOLSTICE_LOGGER: 10/24/2018 12:55:41.306 26041  Information  OnDataReady Found handler for requestUri = '/Config/service/reboot'
    alias: 'API_REBOOT',
    info: 'Pod (whole OS) restarted via /Config/service/restart API. This takes around 90 seconds and will show the boot animation',
    name: 'API Solstice reboot',
    signature: "Found handler for requestUri = '/Config/service/reboot'",
  },
  {
    // 10-10 18:39:11.118  1355  1524 E SOLSTICE_LOGGER: 10/10/2018 18:39:11.118 1524 * Severe      * GetLocalIpv4AddressList Socket error in function ioctl, error 9: EBADF Bad file descriptor. C:\sandbox\Sol-Windows\Common\Platform\Android\Sockets\Src\SocketImpl.cpp 642
    alias: 'IOCTL',
    info: 'An ioctl related log message was found. May be a severe error.',
    name: 'IOCTL',
    signature: 'Socket error in function ioctl',
  },
  {
    // E/SOLSTICE_LOGGER( 7218): 12/31/1969 18:06:43.784 7256 * Severe      * DisableDigitalSignage Digital signage disabled after crash on http://kitchen.screenfeed.com/social/v2/0k1gzfq9dj2r0hjemnf7k24vac.html C:\Users\matts\repos\Sol-Windows\Solstice\Server\Src\GeneralModel.cpp 3028
    alias: 'SIGNAGE_CRASH',
    info: 'A URL crashed digital signage and it was handled by Solstice',
    name: 'Digital Signage Crash',
    signature: "DisableDigitalSignage Digital signage disabled after crash on",
  },
  {
    alias : 'SPLASH_SCREEN_DISCONNECTED',
    info : 'Splash screen cannot retrieve data from the Solstice server',
    name : 'Splash Screen Server failure',
    signature : 'chromium: [INFO:CONSOLE(1)] "Modern splash - error calling /splashdata:'
  },
  {
    // Setting system time to
    alias : 'SETTING_SYSTEM_TIME',
    info : 'Solstice is setting the time from a time server.',
    name : 'Setting time',
    signature : 'Setting system time to'
  },
  {
    // Setting system time to
    alias : 'SETTING_TIME_DAY',
    info : 'Solstice is setting the time from a time server.',
    name : 'Setting time',
    signature : 'AlarmManagerService: Setting time of day to'
  },
  {
    // Audio network latency 543.348000 AVG - 0.000000 MIN - 1954.000000 MAX
    alias : 'AUDIO_NETWORK_LATENCY',
    info : 'TO BE DETERMINED',
    name : 'Audio Network Latency Report',
    signature: 'Audio network latency'
  },
]



// WEBPACK FOOTER //
// ./src/keywords.ts